export default __webpack_public_path__ + "static/media/catalog_step_img04.dd29b16c.svg";